// src/config/workshop.js
export const workshopConfig = {
    id: process.env.VUE_APP_WORKSHOP_ID,
};

if (!workshopConfig.id) {
    console.error('Workshop ID is not configured! Please check your environment variables.');
}

export default workshopConfig;